import { config } from '@/config.js'
import { sendGatewayRequest } from '@/services/gatewayApi.js'

const UTM_STORAGE_KEY = 'utm'

function readStoredUtm() {
  try {
    const raw = localStorage.getItem(UTM_STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

function saveUtm(params) {
  localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(params))
}

export function initUtm(store) {
  const metrikaId = config.yandexMetrikaId
  const urlParams = new URLSearchParams(window.location.search)
  const fromUrl = {}

  for (const [key, value] of urlParams) {
    fromUrl[key] = value
  }

  const params = {
    ...readStoredUtm(),
    ...fromUrl,
    utm_source: window.location.hostname,
  }

  if (window.location.href) {
    params.landing = window.location.href.split('#')[0]
  }
  if (document.referrer) {
    params.referrer = document.referrer
  }

  saveUtm(params)

  const run = () => {
    if (typeof window.ym !== 'function') {
      return
    }

    window.ym(metrikaId, 'getClientID', (clientID) => {
      params.yandexClientID = clientID
      params.counterId = metrikaId
      saveUtm(params)

      sendGatewayRequest({ path: '/api/click', ...params })
        .then((data) => {
          if (data?.utm_id) {
            params.utm_id = data.utm_id
            saveUtm(params)
            store.commit('setUtm', params.utm_id)
          }
          store.commit('setBot')
        })
        .catch((error) => {
          console.log(error)
        })
    })
  }

  if (typeof window.ym === 'function') {
    run()
  } else {
    setTimeout(run, 500)
  }
}
